import React from 'react';
import classes from './RadioGroup.module.scss';

const RadioGroup = ({
  label,
  name,
  options = [],
  value,
  onChange,
  disabled = false,
  direction = 'horizontal', // 'horizontal' or 'vertical'
  className = '',
  labelClassName = '',
  optionsClassName = '',
  optionClassName = '',
}) => {
  const handleOptionClick = (optionValue, isOptionDisabled) => {
    if (!disabled && !isOptionDisabled && onChange) {
      onChange(optionValue);
    }
  };

  const handleInputChange = (optionValue) => {
    if (!disabled && onChange) {
      onChange(optionValue);
    }
  };

  return (
    <div className={`${classes.radioGroup} ${className}`}>
      {label && (
        <div className={`${classes.radioGroup__heading} ${labelClassName}`}>
          {label}
        </div>
      )}
      <div 
        className={`${classes.radioGroup__options} ${
          direction === 'vertical' ? classes.radioGroup__options__vertical : ''
        } ${optionsClassName}`}
      >
        {options.map((option, index) => {
          const isOptionDisabled = disabled || option.disabled;
          return (
            <div
              key={option.value || index}
              className={`${classes.radioGroup__option} ${optionClassName}`}
              onClick={() => handleOptionClick(option.value, isOptionDisabled)}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={() => handleInputChange(option.value)}
                disabled={isOptionDisabled}
                className={classes.radioGroup__option__input}
              />
              <label className={classes.radioGroup__option__label}>
                {option.label}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RadioGroup;